import axios from "axios"
import { AssessmentViewOptionsType } from "shared/types/assessmentTypes"
import { BlockType, ClassMasteryPageReturn, ReviewGradeType, Science35GradeType, StudentMasteryPageReturn } from "shared/types/science35Types"
import { LessonVariety } from "shared/types/moduleTypes"
import { AssignmentResponse } from "shared/types/teacherTypes"
import { StudentReviewAssignmentsPageReturn } from "shared/types/science35Types"

export async function scienceClassMasteryData({ classId, targetBlock } : { classId: string, targetBlock: BlockType }): Promise<ClassMasteryPageReturn> {
    const res = await axios.get("/api/teacher/science/class-mastery", { params: { classId, targetBlock } })
    return res.data
}

export async function scienceStudentMasteryData({ classId, studentId, targetBlock } : { classId: string, studentId: string, targetBlock: BlockType }): Promise<StudentMasteryPageReturn> {
    const res = await axios.get("/api/teacher/science/student-mastery", { params: { classId, studentId, targetBlock } })
    return res.data
}

export async function teacherReviewAssignments({ classID, gradeLevels, targetBlock }: { classID: string, gradeLevels: ReviewGradeType[], targetBlock: BlockType }): Promise<AssignmentResponse[]> {
    const response = await axios.get("/api/teacher/assignments", 
        { params: { 
            classID: classID, 
            gradeLevels: gradeLevels,
            targetBlock: targetBlock,
            assignmentTypes: ["Review"] as LessonVariety[] } 
        })
    return response.data
}


export async function bulkCreateReviewAssignments(data : { classId: string, reviewIds: string[], blockType: BlockType, dueDate: Date, assessmentViewOption: AssessmentViewOptionsType, oneQuestionMode: boolean, randomizable: boolean, useGrade3: boolean, studentIds?: string[] }): Promise<{ message: string, skipped: string[] }> {
    const res = await axios.post("/api/teacher/science/bulk-create", data)
    return res.data
}

export async function studentReviewAssignments({ classId, gradeLevels, hideCompleted } : { classId: string, gradeLevels: Science35GradeType[], hideCompleted: boolean }): Promise<StudentReviewAssignmentsPageReturn> {
    const res = await axios.get("/api/student/science/review-assignments", { 
        params: { classId: classId, gradeLevels: gradeLevels.length > 0 ? gradeLevels : undefined, hideCompleted } 
    })
    return res.data
}
